import { gx } from "@/components/gtax/base";
import { Link } from "react-router-dom";
import { PageHead } from "../GtaxShell";

const VALUES = [
  ["Discipline", "A single instrument, a defined process and risk limits that are never negotiated mid-session."],
  ["Alignment", "The Association is rewarded only from realised profit. When members do not earn, neither do we."],
  ["Transparency", "A published treasury address, a verifiable trading record and a written, digitally signed agreement for every member."],
  ["Discretion", "Membership is by invitation. Member identities and allocations are held in confidence."],
];

export default function GtaxAbout() {
  return (
    <div data-testid="gtax-about-page">
      <PageHead eyebrow="Who we are" title="A private association built around one asset: gold."
        sub="GTA X, the Gold Trading Association, is a product of DFI Holdings. It gives a select circle of members access to a professionally managed XAU/USD mandate, run with the governance and reporting standards of an institutional desk."
        img="/gtax/vault.jpg" />
      <section className="py-24 gx-line">
        <div className="gx-wrap grid lg:grid-cols-12 gap-14 items-center">
          <div className="lg:col-span-6 gx-photo h-[460px]"><img src="/gtax/vault.jpg" alt="Gold vault" /></div>
          <div className="lg:col-span-6">
            <p className="gx-eyebrow">About us</p>
            <h2 className="gx-serif text-4xl md:text-5xl mt-6">Institutional method. Private access.</h2>
            <p className="mt-6 text-[color:var(--mute)] leading-relaxed">
              DFI Holdings builds trading and capital-markets technology from Abu Dhabi. GTA X is its gold-focused member programme:
              a consolidated mandate in which members' USDT allocations are deployed together by a specialist gold desk and
              executed A-book with a regulated broker.
            </p>
            <p className="mt-5 text-[color:var(--mute)] leading-relaxed">
              We do not sell yield. We share realised trading profit, under a written agreement, according to a published profit-share
              schedule, and we tell members plainly that capital is at risk.
            </p>
            <Link to={gx("/strategy")} className="gx-ghost inline-block mt-10" data-testid="gtax-about-strategy-link">Read our strategy</Link>
          </div>
        </div>
      </section>
      <section className="py-24 gx-line gx-ivory">
        <div className="gx-wrap">
          <p className="gx-eyebrow">Our principles</p>
          <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {VALUES.map(([h, p]) => (
              <div key={h} className="gx-card p-8" data-testid={`gtax-value-${h.toLowerCase()}`}>
                <h3 className="gx-caps text-xl">{h}</h3>
                <p className="mt-4 text-[color:var(--mute)] leading-relaxed">{p}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="py-24 gx-line">
        <div className="gx-wrap grid md:grid-cols-3 gap-10">
          {[["The Association", "GTA X · Gold Trading Association"], ["The sponsor", "DFI Holdings · Abu Dhabi, UAE"], ["The desk", "Specialist XAU/USD trading desk, A-book execution"]].map(([k, v]) => (
            <div key={k} className="gx-line pt-6"><div className="gx-eyebrow">{k}</div><div className="gx-serif text-2xl mt-3">{v}</div></div>
          ))}
        </div>
      </section>
    </div>
  );
}
